import React from 'react'
import { useRecordContext } from 'react-admin'

const BookName = () => {
  const record = useRecordContext()
  return <span>Rule Book {record ? `"${record.name}"` : ''}</span>
}

export default BookName
